import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import { Text } from 'src/components';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { Model } from 'src/models';

import ServiceOrderDateTrack from './ServiceOrderDateTrack';

type Props = {
  stages: Api.CompanyProjectSummary.V['serviceOrders'][number]['stages'];
  totalMinutesLogged: number;
};

/**
 * Where the order is up to at a glance: the stage in flight, the span of the
 * dates, and the time already logged against it.
 */
export default function WhereItIsUpToCard({
  stages,
  totalMinutesLogged,
}: Props) {
  const stage = Model.ServiceOrder.getNextStage(stages);
  const track = Model.ServiceOrder.getDateTrack(stages, new Date());

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.card]}>
      <html.div style={[Style.col, styles.cell]}>
        <Text typeface="caption.medium" color="neutral60">
          Current stage
        </Text>
        <Text typeface="body.small.medium" color="neutral100">
          {stage?.name ?? '—'}
        </Text>
      </html.div>

      <html.span style={styles.rule} />

      <html.div style={[Style.col, styles.cell]}>
        <Text typeface="caption.medium" color="neutral60">
          Dates
        </Text>
        {track !== null ? (
          <ServiceOrderDateTrack track={track} />
        ) : (
          <Text typeface="body.small.medium" color="neutral100">
            —
          </Text>
        )}
      </html.div>

      <html.span style={styles.rule} />

      <html.div style={[Style.col, styles.cell]}>
        <Text typeface="caption.medium" color="neutral60">
          Time logged
        </Text>
        <Text typeface="body.small.medium" color="neutral100">
          {Model.ServiceOrder.formatTimeLogged(totalMinutesLogged)}
        </Text>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  card: {
    gap: 16,
    paddingBlock: 14,
    paddingInline: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    backgroundColor: color.neutral0,
    flexWrap: 'wrap',
  },
  cell: {
    gap: 2,
  },
  rule: {
    flexShrink: 0,
    width: 1,
    height: 28,
    backgroundColor: color.neutral20,
  },
});
